var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-main-container"},[_c('v-container',{staticClass:"title-content"},[_c('div',{staticClass:"title-chip"},[_c('div',{staticClass:"overflow-title-chip"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }